import { _ } from '../../../lib';
export const readDynamic = (value, formState) => _.isFunction(value) ? value(formState) : value;
//# sourceMappingURL=types.js.map